import NavigationBar from "../comps/NavigationBar/NavigationBar";
import Footer from "../comps/Footer/Footer";
import ContentCard from "../comps/ContentCard/ContentCard";
import Sidebar from "../comps/Sidebar/Sidebar";

export default function Description() {
  const menu = [
    {
      name: "Inspiration",
      id: "Description-0",
    },
    {
      name: "The Problem",
      id: "Description-1",
    },
    {
      name: "Why AI? - Changing Biology Into a Search Problem",
      id: "Description-3",
    },
    {
      name: "BioRocket - What We Have Done?",
      id: "Description-4",
    },
    {
      name: "Future",
      id: "Description-5",
    },
  ];
  return (
    <div className="general-background">
      <NavigationBar />
      <Sidebar menu={menu} />
      <div className="main-container">
        <p className="title">Project Description:</p>
        <p className="subtitle" key={"Description-0"} id="Description-0">
          • Inspiration:
        </p>
        <ContentCard
          content={`
          <p>
          Nature's diversity offers a vast array of solutions to biological challenges. Prokaryotes have evolved intricate protein delivery systems that enable these organisms to interface with organisms in their surrounding environment. One example, the extracellular Contractile Injection Systems (eCISs), are syringe-like protein complexes that are capable of delivering protein payloads into cells by puncturing the cellular membrane with a spike[1].
          </p>
          <img
          src='https://static.igem.wiki/teams/4826/wiki/description-figure1.png'
          alt='Figure 1. Schematic diagram of an eCIS'
          class='content-figure'
          />
          <p class='content-legend'>
          Figure 1. Schematic diagram of an eCIS
          </p>
          `}
        />
        <p className="subtitle" key={"Description-1"} id="Description-1">
          • The Problem:{" "}
        </p>
        <ContentCard
          content={`
          <p>
          Despite the immense potential to serve as protein delivery tools, only a few eCISs have been experimentally validated to date[1]. The primarily because eCISs are typically encoded by gene clusters consisting of around 16 genes (approximately 20kb), making related wet lab experiments quite challenging. Additionally, the vast majority of microorganisms remain unculturable in the laboratory. These factors have considerably impeded our understanding and engineering efforts related to eCISs. (Figure 2)
          </p>
          <br/>
          <img
          src='https://static.igem.wiki/teams/4826/wiki/decription-figure1-2.png'
          alt='Figure 2. Mining eCISs in massive prokaryotic genomes is a challenging scientific problem.'
          class='content-figure'
          />
          <br/>
          <p class='content-legend'>
          Figure 2. Mining eCISs in massive prokaryotic genomes is a challenging scientific problem.
          </p>
          <br/>
          <p>
          We believe that combining machine learning and computational biology methods with wet lab experiments can help us address this issue.
          <p>
          `}
        />
        <p className="subtitle" key={"Description-3"} id="Description-3">
          • Why AI? - Changing Biology Into a Search Problem
        </p>
        <ContentCard
          content={`
          <p>
          Thanks to the development of prokaryotic microbial genomes, we have gained access to the "book of life". How do we understand the language of life? AI, through the analysis of biological sequences, has accelerated the synthetic biology DBTS cycle, altering the traditional paradigm of biology, enabling us to decipher the mechanisms of life, and reengineer biological functions at an astonishing pace.
          </p>
          <img
          src="https://static.igem.wiki/teams/4826/wiki/description-figure2.jpg"
          alt="Figure 3. Traditional biology projects and tech-forward biology projects have different research paradigms"
          class="content-figure"
          />
          <p class="content-legend">
          Figure 3. Traditional biology projects and tech-forward biology projects have different research paradigms
          </p>
          `}
        />
        <p className="subtitle" key={"Description-4"} id="Description-4">
          • BioRocket - What We Have Done?
        </p>
        <ContentCard
          content={`
          <p>
          This year, our goal is to predict and understand eCISs. The project was named 'BioRocket' because the powerful capabilities of eCISs are like a rocket within a biological system.
          </p>
          <br />
          <p>
          Compared to traditional protein mining methods, BioRocket employs machine learning algorithms and protein structure alignment to predict eCISs in a high-throughput manner from prokaryotic genomes. Our search scope encompassed over eighty thousand bacterial and archaeal species. In the end, we systematically identified 5,524 novel eCISs based on sequence and structural information. Next, we utilized reverse engineering to uncover the remarkable programmability of eCISs by identifying the modules responsible for targeting functionality within eCISs.
          </p>
          <br />
          <p>
          We have integrated all the data into the BioRocket online platform and designed an online prediction feature. Our project has provided insights into the potential of eCISs as protein delivery tools, laying the foundation for our future research and that of other researchers.
          </p>
          `}
        />
        <p className="subtitle" key={"Description-5"} id="Description-5">
          • Future:
        </p>
        <ContentCard
          content={`
          <p>
          The delivery of therapeutic proteins remains a major bottleneck for modern medicine.
          </p>
          <br />
          <p>
          In the future, we plan to commercialize BioRocket (more on <a href="https://2023.igem.wiki/sysu-software/entrepreneurship">Entrepreneurship</a>). By addressing the crucial aspect of therapeutic protein delivery, we aim to drive the development of precision medicine and embrace a world without disease.
          </p>
          <br />
          <p>
          High-throughput robotics, new AI algorithms, and long DNA synthesis will form the foundation of future developments in synthetic biology. As Dennis Gabor once said, "The future cannot be predicted, but futures can be invented." Let's embrace the technological revolution together! 
          </p>
          `}
        />
        <p className="reference-title">• Reference:</p>
        <ContentCard
          content={`
          <p class='reference'>
          [1]Jiang F, Li N, Wang X, et al. Cryo-EM Structure and Assembly of an Extracellular Contractile Injection System. Cell. 2019;177(2):370-383.e15. doi:10.1016/j.cell.2019.02.020
          </p>
          <p class='reference'>
          [2]Kreitz J, Friedrich MJ, Guru A, et al. Programmable protein delivery with a bacterial contractile injection system. Nature. 2023;616(7956):357-364. doi:10.1038/s41586-023-05870-7 
          </p>
          `}
        />
      </div>
      <Footer />
    </div>
  );
}
